import MediaType from '../Constants/MediaType';

/**
 * @param {boolean} isLinear
 * @param {boolean} isLive
 * @returns {MediaType}
 */

const deriveMediaType = (
    isLinear,
    isLive,
) => {
    switch (true) {
        case isLinear:
            return MediaType.LINEAR;
        case isLive:
            return MediaType.LIVE;
        default:
            return MediaType.VOD;
    }
};

export default deriveMediaType;
